module.exports = __webpack_public_path__ + "assets/img/17_1023_big.8ada984b.jpg";